module.exports = __webpack_public_path__ + "img/news_cover_default.0ba62451.png";